<section id="gallery" class="gallery">
  <div class="gallery-head">
    <div>
      <div ppcEyebrow mark class="gallery-eyebrow">{{ 'gallery.eyebrow' | translate }}</div>
      <h2 ppcHeading class="gallery-title">{{ 'gallery.title' | translate }}</h2>
    </div>
    <p ppcLead class="gallery-sub">{{ 'gallery.sub' | translate }}</p>
  </div>

  <div class="gallery-mosaic">
    @for (tile of tiles(); track tile.file; let index = $index) {
      <button
        type="button"
        class="gallery-tile"
        [class.gallery-tile-wide]="tile.wide"
        [style.--tile-columns]="tile.columns"
        [style.--tile-rows]="tile.rows"
        (click)="open(index)"
        [attr.aria-label]="captions()[index]"
      >
        <img [src]="tile.src" [alt]="captions()[index]" loading="lazy" />
      </button>
    }
  </div>

  <dialog
    #lightbox
    class="gallery-lightbox"
    (click)="closeOnBackdrop($event)"
    (keydown.arrowLeft)="prev()"
    (keydown.arrowRight)="next()"
  >
    <div class="gallery-lightbox-frame">
      <div class="gallery-lightbox-bar">
        <button type="button" class="gallery-lightbox-close" (click)="close()" [attr.aria-label]="'gallery.close' | translate">
          {{ 'gallery.closeSymbol' | translate }}
        </button>
      </div>

      <img class="gallery-lightbox-image" [src]="activeTile().src" [alt]="activeCaption()" />

      <div class="gallery-lightbox-bar">
        <div class="gallery-lightbox-controls">
          <button type="button" (click)="prev()" [attr.aria-label]="'gallery.prev' | translate">{{ 'gallery.prevSymbol' | translate }}</button>
          <button type="button" (click)="next()" [attr.aria-label]="'gallery.next' | translate">{{ 'gallery.nextSymbol' | translate }}</button>
        </div>
      </div>
    </div>
  </dialog>
</section>
